import { apiService } from './apiService';

export interface DataValidationResult {
  isLikelyError: boolean;
  severity: 'error' | 'warning' | 'info';
  explanation: string;
  suggestedCorrection?: {
    value: number;
    units: string;
  };
}

export class DataValidationService {
  /**
   * Validate a suspicious data change using LLM
   */
  static async validateDataChange(
    testName: string,
    prevValue: number,
    prevUnits: string,
    prevDate: string,
    currValue: number,
    currUnits: string,
    currDate: string,
    sessionId: string
  ): Promise<DataValidationResult | null> {
    try {
      const response = await apiService.post('/api/validate-data-change', {
        testName,
        prevValue,
        prevUnits,
        prevDate,
        currValue,
        currUnits,
        currDate,
        sessionId
      });

      if (response.status === 'success') {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Failed to validate data change:', error);
      return null;
    }
  }
}